import { SupportEmail } from 'src/util/constants';

const ParcelSearchErrors = {
    startDateOrParcelNum: 'Select a start date or enter a parcel number to search',
    genericError: `Please try again. If you continue to have issues notify IT Support at ${SupportEmail}`,
    noEndDate: 'If no end date is provided, start date should be no more than 7 days in the past',
    periodTooLong: 'The difference between the start and end dates must be no more than 7 days',
    startDateTooOld: 'Please enter a start date no more than 7 days from the end date',
    endDateTooOld: 'Please enter an end date no more than 7 days from the start date',
    requiredLength: 'Please enter at least 4 characters',
    invalidStartDate: 'Start date cannot be after the end date',
    parcelOrManifestNum: 'Please enter a parcel or manifest number',
    invalidCharacter: 'Invalid character "%" entered',
};

export default ParcelSearchErrors;
